import addMonths from "date-fns/addMonths";

import type { APICompsSchema } from "@unit/apis";

export const POST_METRIC_NEW_INFLUENCER_LABEL = "未取得（※PR投稿後に表示）";
export const POST_METRIC_UNAVAILABLE_LABEL = "未取得";

const NEW_INFLUENCER_BADGE_DURATION_MONTHS = 2;

/**
 * PR投稿系メトリクス（インプレッション/いいね/コメント/EG等）の表示文字列を組み立てる。
 * - PR完了件数 0       → "未取得（※PR投稿後に表示）"
 * - PR完了件数 ≥1, 値 0 → "未取得"（メディア種別差分・リンク失効などで集計不可）
 * - PR完了件数 ≥1, 値 ≥1 → 数値（toLocaleString）
 */
export const formatPostMetric = (
  metricValue: number | null | undefined,
  prDoneCount: number | null | undefined,
): string => {
  if (!prDoneCount || prDoneCount < 1) return POST_METRIC_NEW_INFLUENCER_LABEL;
  if (!metricValue || metricValue < 1) return POST_METRIC_UNAVAILABLE_LABEL;
  return metricValue.toLocaleString();
};

/**
 * インフルエンサーが「NEW」バッジ表示対象か判定する。
 * - 登録日ではなく「プロアカウント連携日時」基準
 * - 連携時にプロアカウント用 SNS レコードが新規作成されるため、
 *   `accessTokenExpiresAt` で連携済みと判定できる SNS レコードの `createdAt` を連携日時として扱う
 * - 連携日時から 2 ヶ月以内であれば true
 */
export const isNewInfluencer = (
  snsAccounts:
    | Pick<APICompsSchema["FlatSNSAccountObject"], "type" | "accessTokenExpiresAt" | "createdAt">[]
    | null
    | undefined,
  now: Date = new Date(),
): boolean => {
  if (!snsAccounts?.length) return false;
  const instagram = snsAccounts?.find((sns) => sns.type === "instagram");
  if (!instagram || instagram.accessTokenExpiresAt == null) return false;
  if (typeof instagram.createdAt !== "number" || instagram.createdAt <= 0) return false;

  const linkedDate = new Date(instagram.createdAt * 1000);
  const expiresAt = addMonths(linkedDate, NEW_INFLUENCER_BADGE_DURATION_MONTHS);
  return now.getTime() < expiresAt.getTime();
};
